//frontend/src/components/Notifications.js
import React, { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useSocket } from '../context/SocketContext';

const Notifications = () => {
    const [notification, setNotification] = useState(null);
    const { socket, isConnected } = useSocket();

    useEffect(() => {
        if (!socket || !isConnected) return;

        const handleAppointmentCreated = (data) => {
            setNotification({
                message: `New appointment: ${data.service} at ${new Date(data.startTime).toLocaleString()}`,
                severity: 'info'
            });
        };

        const handleAppointmentConfirmed = (data) => {
            setNotification({
                message: `Appointment confirmed for ${data.service}`,
                severity: 'success'
            });
        };

        const handleAppointmentCancelled = (data) => {
            setNotification({
                message: `Appointment cancelled: ${data.service}`,
                severity: 'warning'
            });
        };

        socket.on('appointment_created', handleAppointmentCreated);
        socket.on('appointment_confirmed', handleAppointmentConfirmed);
        socket.on('appointment_cancelled', handleAppointmentCancelled);

        return () => {
            socket.off('appointment_created', handleAppointmentCreated);
            socket.off('appointment_confirmed', handleAppointmentConfirmed);
            socket.off('appointment_cancelled', handleAppointmentCancelled);
        };
    }, [socket, isConnected]);

    const handleClose = () => {
        setNotification(null);
    };

    return (
        <Snackbar
            open={!!notification}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            {notification && (
                <Alert onClose={handleClose} severity={notification.severity}>
                    {notification.message}
                </Alert>
            )}
        </Snackbar>
    );
};

export default Notifications;